/** Program types for the Add Program form. PPA uses the form's own name. */
export const PROGRAM_TYPES = [
  {
    code: "PPA",
    label: "PPA - Private Pricing Agreement",
  },
  {
    code: "SPP",
    label: "Solution Provider Program (SPP)",
  },
  {
    code: "EDP",
    label: "Enterprise Discount Program (EDP) / Direct Commitment",
  },
  {
    code: "RI",
    label: "Reserve Instance (RI) / Saving Plan (SP)",
  },
];

export const programTypeByCode = (code) =>
  PROGRAM_TYPES.find((program) => program.code === code) || PROGRAM_TYPES[0];
